(() => {
  const buttonSelector = '[data-collection-load-more]';

  const revealAppendedItems = (items) => {
    items.forEach((item) => item.classList.add('scroll-trigger--cancel'));
  };

  const updateProgress = (button, grid) => {
    const wrapper = button.closest('.enyon-collection-load-more');
    const progress = wrapper?.querySelector('[data-collection-progress]');
    if (!progress) return;

    const viewed = grid.querySelectorAll('.grid__item').length;
    const total = Number(progress.dataset.totalProducts || viewed);
    const percent = total > 0 ? Math.min(100, (viewed / total) * 100) : 100;
    const viewedText = progress.querySelector('[data-viewed-products]');
    const totalText = progress.querySelector('[data-total-products-text]');
    const bar = progress.querySelector('[data-progress-bar]');

    if (viewedText) viewedText.textContent = viewed;
    if (totalText) totalText.textContent = total;
    if (bar) bar.style.width = `${percent}%`;
  };

  const setLoading = (button, isLoading) => {
    const label = button.querySelector('[data-load-more-label]');
    const loading = button.querySelector('[data-load-more-loading]');

    button.toggleAttribute('aria-busy', isLoading);
    button.classList.toggle('is-loading', isLoading);

    if (label) label.hidden = isLoading;
    if (loading) loading.hidden = !isLoading;
  };

  const appendNextPage = async (event) => {
    const button = event.target.closest(buttonSelector);
    if (!button || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (button.hasAttribute('aria-busy')) return;

    const grid = document.getElementById(button.getAttribute('aria-controls') || 'product-grid');
    if (!grid) return;

    event.preventDefault();
    setLoading(button, true);

    try {
      const response = await fetch(button.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Failed to load ${button.href}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.getElementById(grid.id);
      const nextButton = doc.querySelector(buttonSelector);

      if (!nextGrid) {
        window.location.href = button.href;
        return;
      }

      const nextItems = nextGrid.querySelectorAll('.grid__item');
      revealAppendedItems(nextItems);
      nextItems.forEach((item) => grid.appendChild(item));
      updateProgress(button, grid);

      if (nextButton) {
        button.href = nextButton.href;
        setLoading(button, false);
      } else {
        button.remove();
      }
    } catch (error) {
      console.error(error);
      window.location.href = button.href;
    }
  };

  document.addEventListener('click', appendNextPage);
})();
